<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 15.5V4.5C1 3.39543 1.89543 2.5 3 2.5H17C18.1046 2.5 19 3.39543 19 4.5V15.5C19 16.6046 18.1046 17.5 17 17.5H10H3C1.89543 17.5 1 16.6046 1 15.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7 7.5L13 12.5M7 12.5L13 7.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>
<style lang="scss" scoped>
svg {
  flex-shrink: 0;
}
</style>
